import React from 'react'
import styled from 'styled-components'

/**
 * 項目の外枠
 */
const ItemBox: React.FC<ItemBoxProps> = (props) => {
  return (
    <StyledItemBox hasField={props.hasField}>{props.children}</StyledItemBox>
  )
}

export type ItemBoxProps = {
  children: React.ReactNode
  hasField?: boolean
}

export const StyledItemBox = styled.div<{
  hasField?: boolean
}>`
  ${(props): string =>
    props.hasField
      ? ''
      : `background: var(--color-content-background);
         border-top: 1px solid var(--color-border);
         border-bottom: 1px solid var(--color-border);`};
`

export default ItemBox
